export default {
  selectLabel: 1,
  content: 2,
  input: 2,
  label: 3,
  addressDropdown: 4,
  addressInput: 5,
  addressLabel: 6,
  addressClearButton: 6,
  inputIcon: 3,
  disclaimerButtonSection: 9,
  /** Loading screen needs to be more than 1 level higher than
   * the content. This is because the autofill dropdown is 1 more
   * than the content it's connected to, and the loader needs
   * to show over it. */
  contentModal: 10,
  loadingScreen: 11,
  /** Error modals should always have the max z-index in the app as it
   * always has the most importance. */
  errorModal: 12,
};
